<template>
	<v-card>
    <v-toolbar color="blue-grey white--text">
      <!-- <v-icon>contacts</v-icon> -->
      <v-toolbar-title class="white--text">เปิดวิชา/กลุ่ม</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        v-model="pagination.q"
        append-icon="search"
        label="ค้นหา"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-tooltip left v-if="hasAccess(allowedRoles)">
        <v-btn color="teal" slot="activator" dark fab @click="addItem()">
          <v-icon>playlist_add</v-icon>
        </v-btn>
        <span>เพิ่ม ปี/ภาคการศึกษา</span>
      </v-tooltip>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
        <td class="text-xs-left">{{ props.item.year }}</td>
        <td class="text-xs-left">{{ props.item.semester }}</td>
        <td class="text-xs-right">
          <v-tooltip left>
            <v-btn icon class="mx-0" slot="activator" @click="viewRates(props.item)">
              <v-icon color="deep-orange accent-2">monetization_on</v-icon>
            </v-btn>
            <span>อัตราค่าตอบแทน</span>
          </v-tooltip>
          <v-tooltip left>
            <v-btn icon class="mx-0" slot="activator" @click="viewItem(props.item)">
              <v-icon color="teal">pageview</v-icon>
            </v-btn>
            <span>ดูข้อมูล</span>
          </v-tooltip>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ pagination.q }}" found no results.
      </v-alert>
    </v-data-table>
    <template>
      <component :is="formDialog" :dialog="dialog" @dialog="dialog = $event"></component>
    </template>

    <v-dialog
      v-model="ratesDialog"
      width="90%"
      scrollable
    >
      <v-card>
        <v-card-title
          class="title red lighten-2 white--text"
          primary-title
        >
          <v-icon dark>monetization_on</v-icon> <span class="ml-2">{{ ratesDialogTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="ratesDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <lastest-rates :lastestRateItems="rateItems"></lastest-rates>
        </v-card-text>

      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
import AcademicYearFormDialog from './formDialog.vue'
import LastestRates from '../../../settings/wageRate/lastestRates'

export default {
  mixins: [ hasAccessMixin ],
  components: {
    AcademicYearFormDialog,
    LastestRates
  },
	data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
      dialog: false,
      formDialog: null,
      ratesDialog: false,
      loading: false,
      headers: [
        { text: '#', sortable: false, align: 'center', width: '100' },
        { text: 'ปีการศึกษา', align: 'left', sortable: true, value: 'year', width: '200' },
        { text: 'ภาคการศึกษา', align: 'left', sortable: false, value: 'semester', width: '200' },
        { sortable: false }
      ],
      pagination: {
        q: '',
        sortBy: 'year',
        page: 1,
        rowsPerPage: 10,
        descending: true,
        totalItems: 0
      },
      items: [],
      selectedItem: {},
      rateItems: [],
      ratesDialogTitle: null
    }
  },
  mounted () {
    this.reload()
  },
  computed: {

  },
  methods: {
    addItem () {
      this.formDialog = 'academic-year-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    viewItem (item) {
      this.$store.dispatch('academicYear/setAcademicYear', item)
      this.$router.push({ name: 'activeCourse', params: { academicYearId: item.id } })
    },
    viewRates (item) {
      this.ratesDialog = true
      this.rateItems = item.rates
      this.ratesDialogTitle = `อัตารค่าตอบแทน ภาคการศึกษาที่ ${item.semesterYear}`
    },
    reload () {
      this.loading = true
      this.$store.dispatch('academicYear/loadItemsAsPage', this.pagination)
        .then((response) => {
          console.log('reload:', response )
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    reset () {
      this.selectedItem = {}
    }
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload()
    },
    'pagination.q' () {
      this.reload()
    },
    'pagination.page' () {
      this.reload()
    },
    'pagination.descending' () {
      this.reload()
    },
    dialog (val) {
      if(!val) {
        setTimeout(()=>{
          this.reset()
          this.formDialog = null
        }, 300)
        this.reload()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/academicYear/index.vue